module.exports = __webpack_public_path__ + "img/gh-12132.asm.e31bbedf.jpg";